import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export function Main(props: Props) {
  return (
    <main className="relative w-full bg-white">
      <div className="absolute left-0 right-0 mx-auto max-w-[60rem] px-3 pt-12">
        {props.children}
      </div>
    </main>
  )
}
